(() => {
  if (window.__piurProductTitlePresentationInstalled) return;
  window.__piurProductTitlePresentationInstalled = true;

  const TITLE_TRANSLATIONS = {
    de: [
      [/P(?:\u00cd|I)UR\s+Recovery\s+Elite\s+Set/gi, 'P\u00cdUR Bambusbettw\u00e4sche Elite-Set'],
      [/P(?:\u00cd|I)UR\s+Recovery\s+Advanced\s+Set/gi, 'P\u00cdUR Bambusbettw\u00e4sche Komfort-Set'],
      [/P(?:\u00cd|I)UR\s+Recovery\s+Essential\s+Set/gi, 'P\u00cdUR Bambusbettw\u00e4sche Einzel-Set'],
    ],
    en: [
      [/P(?:\u00cd|I)UR\s+Recovery\s+Elite\s+Set/gi, 'P\u00cdUR Bamboo Bedding Elite Set'],
      [/P(?:\u00cd|I)UR\s+Recovery\s+Advanced\s+Set/gi, 'P\u00cdUR Bamboo Bedding Comfort Set'],
      [/P(?:\u00cd|I)UR\s+Recovery\s+Essential\s+Set/gi, 'P\u00cdUR Bamboo Bedding Single Set'],
    ],
  };

  const SKIP_SELECTOR = [
    'script',
    'style',
    'template',
    'noscript',
    'textarea',
    'select',
    'option',
    'input',
    '[contenteditable="true"]',
    '[data-piur-title-skip]',
  ].join(',');

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function currentLocale() {
    const docLang = normalizeText(document.documentElement && document.documentElement.lang).toLowerCase();
    if (docLang.startsWith('de')) return 'de';
    if (docLang.startsWith('en')) return 'en';

    const shopifyLocale = normalizeText(
      (window.Shopify && (window.Shopify.locale || window.Shopify.language)) || ''
    ).toLowerCase();
    if (shopifyLocale.startsWith('de')) return 'de';
    if (shopifyLocale.startsWith('en')) return 'en';

    const path = normalizeText(window.location && window.location.pathname).toLowerCase();
    if (/\/de(?:\/|$)/.test(path)) return 'de';
    if (/\/en(?:\/|$)/.test(path)) return 'en';

    return 'en';
  }

  function translateTitleText(value, locale) {
    let output = String(value || '');
    const translations = TITLE_TRANSLATIONS[locale] || TITLE_TRANSLATIONS.en;

    translations.forEach(([pattern, replacement]) => {
      output = output.replace(pattern, replacement);
    });

    return output;
  }

  function shouldSkipNode(node) {
    const element = node instanceof Element ? node : node && node.parentElement;
    return Boolean(element && element.closest(SKIP_SELECTOR));
  }

  function localizeTextNodes(root, locale) {
    if (!root || shouldSkipNode(root)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!normalizeText(node.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (shouldSkipNode(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((textNode) => {
      const translated = translateTitleText(textNode.nodeValue, locale);
      if (translated !== textNode.nodeValue) {
        textNode.nodeValue = translated;
      }
    });
  }

  function localizeAttributes(root, locale) {
    if (!(root instanceof Element)) return;

    const elements = [root, ...Array.from(root.querySelectorAll('[aria-label], [title], [alt]'))];
    elements.forEach((element) => {
      if (!(element instanceof Element) || shouldSkipNode(element)) return;

      ['aria-label', 'title', 'alt'].forEach((attributeName) => {
        const value = element.getAttribute(attributeName);
        if (!value) return;

        const translated = translateTitleText(value, locale);
        if (translated !== value) {
          element.setAttribute(attributeName, translated);
        }
      });
    });
  }

  function localizeProductTitles(root = document.body) {
    const locale = currentLocale();
    if (!root) return;

    localizeTextNodes(root, locale);
    localizeAttributes(root instanceof Element ? root : document.body, locale);
  }

  let timer = 0;
  function scheduleLocalize(root = document.body) {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => localizeProductTitles(root), 0);
  }

  function observe() {
    if (!document.body || window.__piurProductTitlePresentationObserverInstalled) return;
    window.__piurProductTitlePresentationObserverInstalled = true;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const relevantNode = Array.from(mutation.addedNodes).find(
            (node) => node instanceof Element || node.nodeType === Node.TEXT_NODE
          );
          if (relevantNode) {
            scheduleLocalize(relevantNode instanceof Element ? relevantNode : document.body);
            return;
          }
        }

        if (mutation.type === 'characterData') {
          scheduleLocalize(mutation.target.parentElement || document.body);
          return;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      localizeProductTitles();
      observe();
    });
  } else {
    localizeProductTitles();
    observe();
  }
})();
